/*  ─────────────────────────────────────────┐
  SP）header挙動（安定版）
└───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-header-wrapper]');
  if (!header) return;

  const BREAKPOINT = 750; // mobile = < 750px
  const OFFSET = 80; // 何px超えたら隠し始めるか
  const DELTA = 6; // 最小移動量（デッドゾーン）
  const mq = window.matchMedia(`(max-width: ${BREAKPOINT - 1}px)`);

  let lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
  let ticking = false;
  let prevInnerWidth = window.innerWidth;

  function onScroll() {
    // iOSのラバーバンド対策（負になることはないが念のため丸め）
    const curr = Math.max(0, window.scrollY || window.pageYOffset || 0);

    if (mq.matches) {
      // SPだけ実行
      const diff = curr - lastY;

      // 微小な上下は無視してチラつき防止
      if (Math.abs(diff) > DELTA) {
        if (diff > 0 && curr > OFFSET) {
          // 下方向：隠す
          header.classList.add('header--hidden');
        } else if (diff < 0) {
          // 上方向：見せる
          header.classList.remove('header--hidden');
        }
      }
    }

    lastY = curr;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        requestAnimationFrame(onScroll);
        ticking = true;
      }
    },
    { passive: true }
  );

  // 幅が変わったときだけ（=ブレークポイント跨ぎなど）リセット
  window.addEventListener('resize', () => {
    const w = window.innerWidth;

    // 幅が変わっていない＝アドレスバーの高さ変化等 → 何もしない
    if (w !== prevInnerWidth) {
      // PC/SP切替のタイミングでだけ状態リセット
      if (prevInnerWidth < BREAKPOINT !== w < BREAKPOINT) {
        header.classList.remove('header--hidden');
        // 現在位置でlastYを更新（直後のスクロールで誤判定しない）
        lastY = Math.max(0, window.scrollY || window.pageYOffset || 0);
      }
      prevInnerWidth = w;
    }
  });

  // 向き変更で幅が変わるケースも上のresizeに任せる
});

/*  ─────────────────────────────────────────┐
  PC）headerメニュー挙動
└───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dropdown__family').forEach((family) => {
    const previewWrap = family.querySelector('.dropdown__preview');
    const previewImg = previewWrap && previewWrap.querySelector('.preview-img');
    if (!previewImg) return;

    // 1) デフォルトURL（data-default優先）
    const defaultUrl =
      (previewWrap && previewWrap.dataset.default) ||
      previewImg.getAttribute('src') ||
      '';

    // 2) 事前プリロード（初回だけ）
    let preloaded = false;
    const preload = () => {
      if (preloaded) return;
      preloaded = true;
      family.querySelectorAll('[data-image]').forEach((el) => {
        const url = el.dataset.image;
        if (!url) return;
        const img = new Image();
        img.decoding = 'async';
        img.src = url;
      });
    };
    // familyに初めて入ったタイミングでプリロード
    family.addEventListener('pointerenter', preload, { once: true });
    family.addEventListener('focusin', preload, { once: true });

    // 3) 画像差し替え
    const swapTo = (url) => {
      if (!url || previewImg.dataset.current === url) return;
      previewImg.src = url;
      previewImg.dataset.current = url;
    };
    const reset = () => {
      if (defaultUrl) swapTo(defaultUrl);
    };

    // 4) 委譲：family 上で pointerover/focusin を拾い、最寄りの [data-image] を検索
    family.addEventListener('pointerover', (e) => {
      const el = e.target.closest('[data-image]');
      if (!el || !family.contains(el)) return;
      swapTo(el.dataset.image);
    });

    family.addEventListener('focusin', (e) => {
      const el = e.target.closest('[data-image]');
      if (!el || !family.contains(el)) return;
      swapTo(el.dataset.image);
    });

    // 5) family から離れたらデフォルトへ
    family.addEventListener('pointerleave', reset);
    family.addEventListener('focusout', (e) => {
      if (!family.contains(e.relatedTarget)) reset();
    });
  });
});
